import {FilterValueType} from 'festo-react-ui-kit';
import {FilterBase} from '../../interfaces';
import {TypeUseTranslationHook} from '../../features/translation/hooks/useTranslation';

// TO-DO: Add a brief explanation of what the file does.
export function convertSizeToColNumber(size: number): number {
  const MAX_COLUMNS = 12;
  const sizeFraction = size / 100;
  const colNumbers = Array.from(Array(MAX_COLUMNS), (_, i) => i + 1);
  return colNumbers.reduce((prev, curr) =>
    Math.abs(curr / MAX_COLUMNS - sizeFraction) < Math.abs(prev / MAX_COLUMNS - sizeFraction) ? curr : prev,
  );
}

export const filterPreparation = (
  singleFilter: FilterBase,
  storedValue: string | number,
  t: TypeUseTranslationHook,
) => {
  let savedModalSegment: FilterValueType[] = [];

  if (
    (singleFilter.type === 'textsegmentedbutton' || singleFilter.type === 'radiobutton') &&
    Array.isArray(singleFilter.value)
  ) {
    const index = +storedValue - 1;
    savedModalSegment = singleFilter.value.map((modalSegment, index) => {
      if (index === 0) {
        return {
          ...modalSegment,
          label: t('[filterNumShockAbsorberOne]'),
          selected: false,
        };
      } else if (index === 1) {
        return {
          ...modalSegment,
          label: t('[filterNumShockAbsorberTwo]'),
          selected: false,
        };
      } else {
        return {
          ...modalSegment,
          label: t('[filterNumShockAbsorberThree]'),
          selected: false,
        };
      }
    });
    savedModalSegment[index].selected = true;
  }

  return singleFilter.type === 'textsegmentedbutton' || singleFilter.type === 'radiobutton'
      ? {
        ...singleFilter,
        value: savedModalSegment,
      }
      : {
        ...singleFilter,
        value: {...singleFilter.value, data: storedValue},
      };
};

export const cushioningReactionPreparation = (storedValue: FilterValueType[]) => {
  let soft: boolean | null = null;
  let robust: boolean | null = null;

  storedValue.map((value) => {
    if (value.data === 'soft') {
      soft = value.selected ? true : null;
    } else {
      robust = value.selected ? true : null;
    }
    return null;
  });

  return { soft, robust };
};

export const resultFilterValuePreparation = (key: string, storedValue: FilterValueType[]) => {
  switch (key) {
    case 'fixedStop':
      return storedValue[0].selected;

    case 'recommendedResults':
      return  storedValue[0].selected;

    case 'forBatteryProduction':
      return storedValue[0].selected ? true : null;

    case 'mountingType':
      let mountingTypeValue = '';
      storedValue.map((value) => {
        if (value.selected && value.data) {
          mountingTypeValue = value.data as string;
        }
        return null;
      });

      return mountingTypeValue;

    case 'robust':
    case 'soft':
      let value: boolean | null = true;
      storedValue.map((val) => (val.selected ? (value = true) : (value = null)));
      return value;
    case 'cushioningAdjustments':
      const cushioningAdjustmentsValue: string[] = [];
      storedValue.map((value) => value.selected && cushioningAdjustmentsValue.push(value.data as string));

      return cushioningAdjustmentsValue;
    case 'cushioningTechnologies':
      const categoriesValue: string[] = [];
      storedValue.map((value) => value.selected && categoriesValue.push(value.data as string));

      return categoriesValue;
    default:
      return null;
  }
};

type FilterValueObj = {
  name: string;
  newValue: string | number | boolean | string[] | null;
};

export const filterValuePreparation = (filter: FilterBase) => {
  if (filter.value === undefined) {
    if (filter.key === 'cushioningReaction') {
      const softValue =
        filter.filters &&
        filter.filters[0].value &&
        Array.isArray(filter.filters[0].value) &&
        resultFilterValuePreparation('soft', filter.filters[0].value);

      const robustValue =
        filter.filters &&
        filter.filters[1].value &&
        Array.isArray(filter.filters[1].value) &&
        resultFilterValuePreparation('robust', filter.filters[1].value);

      if (softValue === undefined || robustValue === undefined) return null;

      const arrayObj: FilterValueObj[] = [
        {
          name: 'soft',
          newValue: softValue,
        },
        {
          name: 'robust',
          newValue: robustValue,
        },
      ];

      return arrayObj;
    } else if (filter.filters) {
      const arrayChildren = filter.filters;

      const { value } = arrayChildren[0];

      if (!Array.isArray(value) || value === undefined) return null;

      const key = value.map((fil) => fil.data);

      if (key[0] === 'festoRecommendedResult') {
        key[0] = key[0].replace('festoR', 'r'); // Convert festoRecommendedResults to recommendedResults
        key[0] += 's';
      }
      const resultFilterValue = resultFilterValuePreparation(key + '', value);

      const obj: FilterValueObj = {
        name: key + '',
        newValue: resultFilterValue,
      };

      return obj;
    }
    return null;
  }

  if (!Array.isArray(filter.value)) {
    const obj: FilterValueObj = {
      name: filter.key,
      newValue: filter.value.data,
    };
    return obj;
  } else if (filter.key === 'numShockAbsorbers' && Array.isArray(filter.value)) {
    let textSegmentedValue = 1;
    filter.value.forEach((children) => {
      if (children.selected && Number.isInteger(children.data)) {
        textSegmentedValue = +children.data;
      }
    });
    return {
      name: filter.key,
      newValue: textSegmentedValue,
    };
  } else {
    const resultFilterValue = resultFilterValuePreparation(filter.key, filter.value);

    const obj: FilterValueObj = {
      name: filter.key,
      newValue: resultFilterValue,
    };
    return obj;
  }
};
